<template>
  <a-row type="flex" justify="center" style="height: 5vh">
    <a-col :span="7" class="team_index_bar_item">
      <router-link to="/team_en/post_investment_operation/post_investment">
        <div class="bar_item item_focus" tabindex="1" id="post_investment">Portfolio Management</div>
      </router-link>
    </a-col>
    <a-col :span="6" class="team_index_bar_item">
      <router-link to="/team_en/post_investment_operation/legal">
        <div class="bar_item" tabindex="2" id="legal">Legal Team</div>
      </router-link>
    </a-col>
    <a-col :span="7" class="team_index_bar_item">
      <router-link to="/team_en/post_investment_operation/operation">
        <div class="bar_item" tabindex="3" id="operation">Support Team</div>
      </router-link>
    </a-col>
  </a-row>
</template>

<script>
import {onBeforeRouteUpdate} from 'vue-router'
import {onMounted} from "vue";

export default {
  name: 'Team_post_investment_operation_bar_en',
  setup() {
    onBeforeRouteUpdate((from, to) => {
      let from_id = ''
      let to_id = ''
      if (from.name.search("post_investment") >= 0) {
        from_id = 'post_investment'
      } else if (from.name.search("legal") >= 0) {
        from_id = 'legal'
      } else if (from.name.search("operation") >= 0) {
        from_id = 'operation'
      }
      if (to.name.search("post_investment") >= 0) {
        to_id = 'post_investment'
      } else if (to.name.search("legal") >= 0) {
        to_id = "legal"
      } else if (to.name.search("operation") >= 0) {
        to_id = "operation"
      }
      //from 是下一个目标地址 to是上一个来源的地址
      document.getElementById(to_id).classList.remove("item_focus")
      document.getElementById(from_id).classList.add("item_focus")
    })

    onMounted(() => {
      if (document.getElementById("legal").classList.value.search("item_focus") >= 0) {
        document.getElementById("legal").classList.remove("item_focus")
      }
      if (document.getElementById("post_investment").classList.value.search("item_focus") >= 0) {
        document.getElementById("post_investment").classList.remove("item_focus")
      }
      if (document.getElementById("operation").classList.value.search("item_focus") >= 0) {
        document.getElementById("operation").classList.remove("item_focus")
      }

      if (window.location.href.search("legal") >= 0) {
        document.getElementById("legal").classList.add("item_focus")
      } else if (window.location.href.search("post_investment_operation/post_investment") >= 0) {
        document.getElementById('post_investment').classList.add("item_focus")
      } else if (window.location.href.search("post_investment_operation/operation") >= 0) {
        document.getElementById('operation').classList.add("item_focus")
      }

    })
  }
}
</script>

<style scoped>
.team_index_bar_item {
  background: grey;
  line-height: 5vh;
  margin: 0.1vw;
}

.bar_item {
  color: white;
}

.item_focus {
  background-color: #2f54eb;
}
</style>